import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUnlock, FiRepeat, FiUserCheck } = FiIcons;

const SelfHelp = () => {
  return (
    <section className="py-24 bg-white border-t border-gray-100">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-black mb-8">Unser Selbsthilfe-Prinzip: Sie bleiben unabhängig.</h2>
          <p className="text-xl text-gray-600 mb-12">
            Unser Ziel ist es nicht, Sie abhängig zu machen. Wir geben Ihnen das Wissen und die Struktur der System-Architektur, damit Sie die Kontrolle behalten.
          </p>
          
          <div className="grid md:grid-cols-3 gap-12">
            <div>
              <SafeIcon icon={FiUnlock} className="text-4xl text-azure-600 mx-auto mb-4" />
              <h4 className="font-bold mb-2">Kein Vendor Lock-in</h4>
              <p className="text-sm text-gray-500">Sie sind nicht an bestimmte Tools oder Anbieter gebunden.</p>
            </div>
            <div>
              <SafeIcon icon={FiRepeat} className="text-4xl text-azure-600 mx-auto mb-4" />
              <h4 className="font-bold mb-2">Eigene Umsetzung</h4>
              <p className="text-sm text-gray-500">Nutzen Sie unsere System-Architektur für Ihr internes Team oder externe Partner.</p>
            </div>
            <div>
              <SafeIcon icon={FiUserCheck} className="text-4xl text-azure-600 mx-auto mb-4" />
              <h4 className="font-bold mb-2">Wissens-Transfer</h4>
              <p className="text-sm text-gray-500">Wir befähigen Sie, Ihre Systeme selbst zu verstehen und zu steuern.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SelfHelp;